import * as React from 'react';
import Select from 'react-select';
import { isNull, isArray, isObject, isString } from 'lodash';
import { HelpBlock } from 'react-bootstrap';
import { WrappedFieldProps } from 'redux-form';
import { OptionComponent, valueComponent } from '../../helpers/SessionCam';

export const parseValue = (input: any) => {
  if (isNull(input)) { return ''; }

  if (isArray(input) && input.length && isObject(input[0])) {
    return input.map((item) => String((item as any).value));
  }

  if (isObject(input) && 'value' in (input as any)) {
    return String((input as any).value);
  }

  if (isString(input)) {
    // tslint:disable-next-line:ban-types
    return typeof input === 'string' ? input : (input as String).valueOf();
  }

  return String(input);
};

export interface ISelectControlOwnProps {
  clearable?: boolean;
  options: any;
  placeholder?: string;
  className?: string;
  id?: string;
  isInvalid?: boolean;
}

type ISelectControlProps = ISelectControlOwnProps & WrappedFieldProps;

const SelectControl: React.SFC<ISelectControlProps> = ({
 clearable = true,
 input,
 options,
 placeholder,
 className,
 meta,
 id,
 isInvalid,
}) => {
  const onBlur = () => input.onBlur(parseValue(input.value));
  const onChange = (value: any) => input.onChange(parseValue(value));

  const hasError = !!((meta.touched && meta.error) || isInvalid);

  return (
      <div className={hasError ? 'has-error' : ''}>
        <Select
            value={input.value}
            valueComponent={valueComponent}
            className={meta.dirty ? (className ? className + ' dirty-field' : 'dirty-field') : className}
            onChange={onChange}
            onBlur={onBlur}
            clearable={clearable}
            id={id}
            placeholder={placeholder}
            options={options}
            optionComponent={OptionComponent}
        />
        {hasError && <HelpBlock>{meta.error}</HelpBlock>}
      </div>
  );
};

export default SelectControl;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/SelectControl/index.tsx